var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5468 4.72675C18.7252 5.19575 19.0857 6.82908 19.5675 7.35408C20.0493 7.87908 20.7388 8.05758 21.1203 8.05758C23.148 8.05758 24.7918 9.70142 24.7918 11.7279V18.4887C24.7918 21.2071 22.5868 23.4121 19.8685 23.4121H8.13183C5.41233 23.4121 3.2085 21.2071 3.2085 18.4887V11.7279C3.2085 9.70142 4.85233 8.05758 6.88 8.05758C7.26033 8.05758 7.94983 7.87908 8.43283 7.35408C8.91466 6.82908 9.274 5.19575 10.4523 4.72675C11.6318 4.25775 16.3685 4.25775 17.5468 4.72675Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4116 11.0833H20.4221",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7087 15.3163C17.7087 13.2676 16.0485 11.6074 13.9998 11.6074C11.9512 11.6074 10.291 13.2676 10.291 15.3163C10.291 17.3649 11.9512 19.0251 13.9998 19.0251C16.0485 19.0251 17.7087 17.3649 17.7087 15.3163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCamera);
export default __webpack_public_path__ + "static/media/light-camera.aec58f41651c38efdea230c2523b6478.svg";
export { ForwardRef as ReactComponent };